import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "@/components/theme-provider";

export function Toaster() {
  const { theme } = useTheme();
  return <SonnerToaster position="bottom-right" richColors closeButton theme={theme} />;
}
